import React, {useEffect, useState} from 'react';
import {CheckCircle, X} from "react-feather";

const Notification = ({message, type, onClose}) => {
    const [showNotification, setShowNotification] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowNotification(false);
            onClose();
        }, 30000);

        return () => clearTimeout(timer);
    }, [onClose]);

    function closeNotification() {
        setShowNotification(false);
        onClose();
    }

    return (showNotification &&
        <div className='sl-p-4 sl-fixed sl-bg-white sl-rounded-lg sl-shadow-lg sl-left-5 sl-bottom-8'>
            <div className='sl-flex sl-justify-center sl-gap-4'>

                {type === 'success' && <div
                    className="sl-flex sl-badge sl-rounded-full sl-border-2-point-5 sl-badge-success">
                    <CheckCircle className='sl-m-auto sl-text-success-600' size={20}/>
                </div>}

                {type === 'error' && <div
                    className="sl-flex sl-badge sl-rounded-full sl-border-2-point-5 sl-badge-error">
                    <X className='sl-m-auto' size={20}/>
                </div>}

                <div className="sl-font sl-btn-sm sl-font-medium sl-text-gray-900">
                    {message}
                </div>

                <button className="sl-btn sl-btn-clear sl-p-2 sl-mb-auto" onClick={closeNotification}>
                    <X size={20}/>
                </button>
            </div>
        </div>
    );
};

export default Notification;
